// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"acb6f8d6","787":"93a8b22a","802":"e6dea127"}[chunkId] + ".chunk.js";
};